import { entryBarItems } from '@/mocks/home';

export default function EntryBar() {
  return (
    <div className="w-full rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
        {entryBarItems.map((item) => (
          <button
            key={item.label}
            type="button"
            className="group relative flex items-center gap-3 px-4 py-4 text-left transition-colors cursor-pointer hover:bg-primary-50"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${item.icon} text-lg`}></i>
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-label font-medium text-foreground-950 whitespace-nowrap">
                {item.label}
              </span>
              <span className="block text-xs font-label text-foreground-500 truncate">{item.desc}</span>
            </span>
            <i className="ri-arrow-right-s-line ml-auto text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
          </button>
        ))}
      </div>
    </div>
  );
}